import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getTasteOfGoldPromoCampaign from 'takeovers/tasteOfGoldTakeover/selectors/getTasteOfGoldPromoCampaign'

const getCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.transferAirports,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getTasteOfGoldPromoCampaign(state),
  (
    userBenefits,
    isInternationalTrip,
    airportCodes = EmptyArray,
    isCurrentRegionUserLoyaltyRegion,
    postPurchase,
    tasteOfGoldCampaign,
  ): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion || !!postPurchase) return false

    const transferBenefit = userBenefits?.find(benefit => benefit.code === 'airport_transfer')
    const hasTransferBenefit = !!transferBenefit && (transferBenefit.unlimited || !!transferBenefit.remaining)

    // Can redeem airport transfers when they have some remaining (or Taste of Gold campaign is active),
    // it's an international order and our config says we have transfer airports available
    return airportCodes.length > 0 &&
      (hasTransferBenefit || !!tasteOfGoldCampaign) &&
      isInternationalTrip
  },
)

export default getCanRedeemTransferLoyaltyBenefit
